//import * as lib from '../lib/lib'
import $ from 'jquery'

class ExpandedTip {
  constructor(element) {
    if (!element) return

    this.element = element

    this.collapseText()
    this.expandText()
  }

  collapseText() {
    $(this.element).find('.b-tip__body').slideUp()
  }

  expandText() {
    $(this.element)
      .find('.b-tip__header')
      .on('click', (e) => {
        const $item = $(e.currentTarget)

        console.log('rotate', $item.find(".b-tip__title"))
        $item.find(".b-tip__txt").toggleClass("rotate")
        $(this.element).find('.b-tip__body').slideToggle()
      })
  }
}

export default ExpandedTip
